import type { KycEducationSectionModel, KycEducationSectionDto } from '../types/pay-identity-kyc'

export const transformKycEducationDto = (
  kycEducationSectionDto: KycEducationSectionDto,
): KycEducationSectionModel => ({
  title: kycEducationSectionDto.title,
  body: kycEducationSectionDto.body,
  iconUrl: kycEducationSectionDto.icon_url,
  darkIconUrl: kycEducationSectionDto.dark_icon_url,
  icon: kycEducationSectionDto.icon,
})

export const transformKycEducationDtos = (
  kycEducationSectionDtos: Array<KycEducationSectionDto>,
): Array<KycEducationSectionModel> => kycEducationSectionDtos.map(transformKycEducationDto)
